import { Input } from 'antd';

interface TextDocRendererProps {
  content: string;
  editable: boolean;
  onChange: (newContent: string) => void;
}

function TextDocRenderer({ content, editable, onChange }: TextDocRendererProps) {
  return (
    <Input.TextArea
      value={content}
      onChange={(e) => onChange(e.target.value)}
      readOnly={!editable}
      rows={12}
      style={{
        fontFamily: 'monospace',
        resize: 'vertical',
      }}
    />
  );
}

export default TextDocRenderer;
